<template>
  <div
    class="ihk__rally-booking-container"
    v-if="events.length && allowBooking"
  >
    <div class="ihk__upper-section">
      <icon
        :icon="['far', 'calendar-check']"
        :style="{ color: 'white', marginRight: '9px', marginBottom: '3px' }"
        size="lg"
      />
      <p class="ihk__booking-title" style="cursor: pointer" v-if="step === 1">
        Jetzt Termin buchen
      </p>
      <p class="ihk__booking-title" v-if="!bookedEvent && step === 2">
        Wähle deinen Termin
      </p>
      <p class="ihk__booking-title" v-if="bookedEvent && step === 2">
        Dein Termin
      </p>
    </div>

    <div class="ihk__lower-section">
      <div v-if="step === 1">
        <p class="ihk__booking-text">
          {{
            introText ||
            "Hier kannst du einen Termin für die kommende Lehrstellnrallye buchen."
          }}
        </p>
        <p
          class="ihk__booking-text"
          style="margin: 0 0 20px 0"
          v-if="userId == 0"
        >
          <strong>{{
            loginText ||
            "Um einen Termin buchen zu können musst du ich zuerst anmelden."
          }}</strong>
        </p>
        <button :disabled="loading" class="ihk__book-btn" v-if="userId != 0" @click="step = 2">
          Termin buchen
        </button>
        <a
          :href="`/wp-login.php?action=register&redirect_to=${location.href}`"
          class="ihk__book-btn"
          v-if="userId == 0"
          >Anmelden</a
        >

      </div>

      <div v-if="!bookedEvent && step === 2 && userId != 0">
        <div v-if="eventIsFullyBooked" class="ihk__overbooking-message">
          <p class="ihk__overbooking-title">
            Der Termin konnte nicht gebucht werden.
          </p>
          <p style="margin-bottom: 8px">
            Die maximale Teilnehmeranzahl für den von dir gewählten Termin ist
            bereits erreicht.
          </p>
          <p>
            <strong v-if="availableEvents.length"
              >Wähle bitte eines der anderen Zeitfenster.</strong
            >
          </p>
        </div>

        <p v-if="availableEvents.length === 0">
          <strong
            >Es sind bei diesem Unternehmen leider keinen weiteren Termine
            verfügbar.</strong
          >
        </p>

        <ul class="ihk__booking-list">
          <button
            v-for="event in availableEvents"
            :key="event.id"
            :disabled="loading"
            @click="bookEvent(event)"
          >
            {{ format(new Date(event.start_date), "HH:mm") }}
            -
            {{ format(new Date(event.end_date), "HH:mm") }}
          </button>
        </ul>

        <div class="loading-text" v-if="loading">
          Deine Buchung wird verarbeitet...
        </div>
      </div>

      <div
        class="ihk__booking-info"
        v-if="bookedEvent && step === 2 && userId != 0"
      >
        <div class="ihk__icon">
          <icon
            :icon="['far', 'check-circle']"
            :style="{ color: '#01C97C' }"
            size="2x"
          />
        </div>
        <div class="ihk__registration-info">
          <p class="ihk__info-title">
            Dein Termin ist für
            <strong
              >{{ format(new Date(bookedEvent.event.start_date), "HH:mm") }}-{{
                format(new Date(bookedEvent.event.end_date), "HH:mm")
              }}</strong
            >
            am
            <strong>{{
              format(new Date(bookedEvent.event.start_date), "dd.MM")
            }}</strong>
            gebucht
          </p>
          <p class="ihk__info-body">
            {{
              bookedText ||
              "Du wirst vor der Rallye eine E-Mail erhalten mit einer Übersicht über all deine gebuchten Termine."
            }}
          </p>
          <button
            class="ihk__info-cancel-btn"
            v-if="canBeDeleted"
            @click="deleteRegistration"
            @disabled="loading"
          >
            Termin stornieren
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { format, differenceInHours, areIntervalsOverlapping } from "date-fns";

const URL = "/wp-json/wp/v2";

export default {
  name: "book-event",

  props: ["companyId", "userId", "nonce"],

  data() {
    return {
      events: [],
      userRegistrations: [],
      // companyId: 1537,
      // userId: 1,
      step: 1,
      location: window.location,
      loading: false,

      allowBooking: false,
      limitDate: false,
      activeBookingDate: null,
      introText: "",
      loginText: "",
      bookedText: "",
      eventIsFullyBooked: false,
    };
  },

  async created() {
    this.loading = true;
    axios.defaults.headers.common["X-WP-Nonce"] = this.nonce;
    
    if (window.wpApiSettings) {
      axios.defaults.headers.common["X-WP-Nonce"] = window.wpApiSettings.nonce;
    }

    await this.fetchSettings();
    await this.fetchData();
    this.loading = false;
  },

  computed: {
    availableEvents() {
      let eventsWithRoom = this.events.filter(
        (event) =>
          Number(event.max_participants) > event.participants.length ||
          !event.max_participants
      );

      // Sort events by ealierst start_date
      eventsWithRoom.sort((a, b) => {
        return new Date(a.start_date) - new Date(b.start_date);
      });

      // Check if User has overlapping events
      return eventsWithRoom.filter((event) => {
        let userHasTime = true;

        this.userRegistrations.forEach((registration) => {
          let overlap = areIntervalsOverlapping(
            {
              start: new Date(event.start_date),
              end: new Date(event.end_date),
            },
            {
              start: new Date(registration.event.start_date),
              end: new Date(registration.event.end_date),
            }
          );

          if (overlap) userHasTime = false;
        });

        return userHasTime;
      });
    },

    bookedEvent() {
      return this.userRegistrations.find(
        (registration) => registration.event.company_id == this.companyId
      );
    },

    canBeDeleted() {
      return (
        differenceInHours(new Date(), new Date(this.bookedEvent.date)) < 25
      );
    },
  },

  methods: {
    format,

    async fetchSettings() {
      let { data } = await axios.get("/wp-json/rallye-termine/v1/settings");

      this.allowBooking = Boolean(data["ihk__allow-booking"]);
      this.limitDate = Boolean(data["ihk__limit-date"]);
      if (data["ihk__active-booking-date"])
        this.activeBookingDate = new Date(data["ihk__active-booking-date"]);
      this.introText = data["ihk__intro-text"];
      this.loginText = data["ihk__login-text"];
      this.bookedText = data["ihk__booked-text"];
    },

    async fetchData() {
      let eventUrl = `${URL}/event?company_id=${this.companyId}&exclude_past_events=yes`;

      if (this.limitDate) {
        eventUrl = `${URL}/event?company_id=${
          this.companyId
        }&exclude_past_events=yes&on_date=${this.format(
          this.activeBookingDate,
          "yyyy-MM-dd"
        )}T02:00`;
      }

      let res = await axios.get(eventUrl);
      this.events = res.data;

      if (this.userId == 0) return;
      res = await axios.get(
        `${URL}/registration?user_id=${this.userId}&include_event=yes`
      );

      this.userRegistrations = res.data;
      if (this.bookedEvent) this.step = 2;
    },

    async bookEvent(event) {
      if (this.loading == true) return;

      this.loading = true;
      let res;

      try {
        res = await axios.post(
          `/wp-json/rallye-termine/v1/add_registration`,
          {
            user_id: this.userId,
            event_id: event.id,
            status: "publish",
          }
        );
      } catch (err) {
        if (err.response.status === 400) {
          this.eventIsFullyBooked = true;
          this.events = [];
          this.fetchData();
        }

        return;
      }

      let registration = res.data;
      registration.event = this.events.find((ev) => ev.id === event.id);

      // Add new registration to state
      let userRegistrations = [...this.userRegistrations];
      userRegistrations.push(res.data);
      this.userRegistrations = userRegistrations;

      this.loading = false;
    },

    async deleteRegistration() {
      this.loading = true;
      let registrationId = this.bookedEvent.id;
      let res = await axios.delete(`${URL}/registration/${registrationId}`);
      if (res.status !== 200) return; // TODO, add user feedback

      this.userRegistrations = this.userRegistrations.filter(
        (reg) => reg.id !== registrationId
      );

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ihk__rally-booking-container {
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  margin: 10px 0;
  margin-top: 5%;
  border-radius: 5px;
  overflow: hidden;

  @media only screen and (min-width: 768px) {
    margin-right: 15%;
  }

  p {
    margin: 0;
  }

  .ihk__upper-section {
    display: flex;
    align-items: center;
    background: #0093d2;
    color: white;
    padding: 9px 14px;

    @media only screen and (max-width: 768px) {
      padding: 9px 10px;
    }

    p {
      font-size: 110%;
      color: white;

      @media only screen and (max-width: 768px) {
        font-size: 100%;
      }
    }
  }

  .ihk__lower-section {
    background: white;
    padding: 16px 14px;

    @media only screen and (max-width: 768px) {
      padding: 20px 10px;
    }

    .ihk__booking-list {
      display: flex;
      flex-direction: column;
      width: 100%;
      list-style: none;
      padding: 8px 0 4px 0;
      margin: 0;

      button {
        background: #f0f0f0;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        color: #0093d2;
        margin-bottom: 7px !important;
        cursor: pointer;

        &:disabled {
          background: #e6e6e6;
          color: #868686;
          cursor: not-allowed;
          animation: blink 1.5s infinite;
        }

        &:hover {
          background: #e6e6e6;
        }
      }
    }

    p.ihk__booking-text {
      margin-bottom: 10px;
      line-height: 1.4;
    }

    .ihk__booking-info {
      display: flex;

      .ihk__icon {
        padding-right: 12px;

        @media only screen and (max-width: 768px) {
          padding-right: 8px;
        }
      }

      p.ihk__info-title {
        color: #0093d2;
        font-size: 105%;
        line-height: 1.3;

        @media only screen and (max-width: 768px) {
          font-size: 110%;
        }
      }

      p.ihk__info-body {
        color: #868686;
        font-size: 90%;
        line-height: 1.3;
        margin: 7px 0;
      }
    }
  }

  .ihk__overbooking-title {
    font-size: 110%;
    color: #e71600;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .ihk__book-btn,
  .ihk__info-cancel-btn {
    background: #0093d2;
    border: none;
    color: white;
    padding: 8px 10px;
    border-radius: 5px;
    margin-top: 5px;

    &:disabled {
      background: #ccc;
      border-color: #ccc;
      color: #757575;
      cursor: not-allowed;
    }
  }
}

.loading-text {
  text-align: center;
  color: #0093d2;
  font-weight: 600;

  // Animate loading text
  animation: blink 1.5s infinite;
}

@keyframes blink {
    0% {
      opacity: 0.4;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.4;
    }
  }
</style>
